import { WorkspaceBoardRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/boards/$boardId')({
  component: WorkspaceBoardRoute,
});
